export const QUALITY_ORDER = Object.freeze( [ 'performance', 'balanced', 'quality', 'cinematic' ] );

export const CLOUD_QUALITY_PRESETS = Object.freeze( {
	performance: Object.freeze( {
		label: 'Performance',
		renderScale: 0.55,
		viewSteps: 48,
		lightSteps: 2,
		detailOctaves: 1,
		jitterStrength: 1,
		animatedJitter: true
	} ),
	balanced: Object.freeze( {
		label: 'Balanced',
		renderScale: 0.72,
		viewSteps: 76,
		lightSteps: 4,
		detailOctaves: 2,
		jitterStrength: 0.9,
		animatedJitter: true
	} ),
	quality: Object.freeze( {
		label: 'Quality',
		renderScale: 0.85,
		viewSteps: 112,
		lightSteps: 5,
		detailOctaves: 2,
		jitterStrength: 0.75,
		animatedJitter: true
	} ),
	cinematic: Object.freeze( {
		label: 'Cinematic',
		renderScale: 1,
		viewSteps: 156,
		lightSteps: 7,
		detailOctaves: 3,
		jitterStrength: 0.6,
		animatedJitter: true
	} )
} );

export function getQualityPreset( name = 'balanced' ) {

	const preset = CLOUD_QUALITY_PRESETS[ name ];

	if ( ! preset ) {

		throw new RangeError( `Unknown cloud quality preset: ${ name }` );

	}

	return { ...preset };

}

export function getQualityIndex( name ) {

	return QUALITY_ORDER.indexOf( name );

}
